/**
 * Punto de entrada.
 *
 * Monta React, el router y la cache de datos. La cache no reintenta errores de
 * permisos ni de autenticacion: si el backend dijo 401/403, insistir solo suma
 * ruido y ademas la renovacion de token ya la maneja `lib/api`.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import '@/index.css';
import { MarcaShell } from '@/marca/MarcaShell';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (intentos, error) => {
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return intentos < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

const contenedor = document.getElementById('root');
if (contenedor === null) {
  throw new Error('No se encontro el nodo #root: revisá index.html.');
}

createRoot(contenedor).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Los `future` flags adoptan hoy el comportamiento de React Router 7. Sin
          ellos la consola escupe dos advertencias en CADA arranque, y una consola
          con ruido permanente es una consola que nadie mira cuando aparece el
          error que importa. */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* Los textos que el dueno del producto edita desde su consola: el
            aviso de mantenimiento arriba de todo y el pie abajo de todo, en
            TODAS las pantallas —ingreso, ERP y error de conexion—.
            Envuelve `<App/>` y no se mete adentro a proposito: asi el aviso se
            sigue viendo aunque la app de adentro se caiga, que es justo cuando
            hace falta. Ver `src/marca/MarcaShell.tsx`. */}
        <MarcaShell>
          <App />
        </MarcaShell>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
